export default __webpack_public_path__ + "static/media/hack-mobile.01b5bb51.png";